<p class="history-head">Upload History</p>
@if (loading) {
  <div class="loading-indicator">
    <p-progressSpinner></p-progressSpinner>
  </div>
}
<p-table
  #dt
  [columns]="scrollableCols"
  [value]="privateWorkshopUploadHistory"
  selectionMode="single"
  [loadingIcon]="loadingIcon"
  [showLoader]="true"
  [scrollable]="true"
  [style]="{ width: '100%' }"
  scrollHeight="550px"
  dataKey="m365eventId"
  [paginator]="true"
  [rows]="dataViewRecsPerPage"
  [pageLinks]="pageLinksPerPage"
  paginatorPosition="top"
  (onPage)="pageChange($event)"
  (onFilter)="applyFilter($event)"
  exportFilename="M365EventRecords"
  class="table">
  <ng-template pTemplate="caption">
    <div class="align-table-head">
      <div class="ui-g-4 filter">
        <span class="filter-by">Filter by: </span>
        <p-select
          [showClear]="true"
          #dropdown
          [options]="fileTypes"
          optionLabel="type"
          placeholder="Select Customer or Partner"
          (onChange)="filterTable($event)"></p-select>
      </div>

      <div style="align-content: space-evenly">
        <p-button
          class="ui-state-default ui-button-info"
          (click)="showUploadDialog()"
          [disabled]="!isWorkshopTypeSelected">
          Upload Documents
        </p-button>
      </div>
    </div>
  </ng-template>

  <ng-template #header let-columns>
    <tr class="row">
      <th class="colsmall">Active</th>
      <th class="collarge">File Name</th>
      <th class="colsmall">File Type</th>
      <th [pSortableColumn]="'createdOn'" class="colsmall">
        Upload Date<p-sortIcon [field]="'createdOn'"> </p-sortIcon>
      </th>
      <th class="colmedium">Uploaded by</th>
      <th class="colmedium">Errors</th>
    </tr>
  </ng-template>
  <ng-template #body let-rowData let-columns="columns">
    <tr class="row">
      <td class="colsmall">
        @if (rowData.active) {
          <div class="active-box active-box-green">Yes</div>
        }
        @if (!rowData.active) {
          <div class="active-box active-box-red">No</div>
        }
      </td>
      <td
        class="collarge"
        tooltipPosition="top"
        pTooltip="{{ rowData.documentDisplayName }}">
        <a target="_blank" href="{{ rowData.documentBlobUrl }}">{{
          rowData.documentDisplayName
        }}</a>
      </td>
      <td class="colsmall">
        <span>{{ rowData.fileType }}</span>
      </td>
      <td class="colsmall">
        <span>{{ rowData.createdOn | date: 'MM/dd/yyyy' }}</span>
      </td>
      <td
        class="colmedium"
        tooltipPosition="top"
        pTooltip="{{
          rowData.createdByUser === null ? '' : rowData.createdByUser.fullName
        }}">
        @if (rowData.createdByUser) {
          <span>{{ rowData.createdByUser.fullName }}</span>
        }
      </td>
      <td class="colmedium">
        @if (!rowData.uploadResult.hasWarning) {
          <span>None</span>
        }
        @if (rowData.uploadResult.hasWarning) {
          <a
            (click)="viewLog(rowData.uploadResult, rowData.fileType)"
            (keydown.enter)="viewLog(rowData.uploadResult, rowData.fileType)"
            tabindex="0"
            >view log</a
          >
        }
      </td>
    </tr>
  </ng-template>
</p-table>
@if (!isWorkshopTypeSelected) {
  <div class="empty-table">
    <p>Select Workshop name to view Upload History</p>
  </div>
}
@if (isWorkshopTypeSelected && !privateWorkshopUploadHistory.length) {
  <div class="empty-table">
    <p>No upload history available for the above selection.</p>
  </div>
}
<app-document-upload
  #uploadDocumentDialogue
  (uploadCompletedEvent)="reset()"></app-document-upload>
<app-access-list-error-log
  #viewLogModal
  [showLogs]="showLogs"></app-access-list-error-log>
